import { copyTextWithNotify } from "@/helpers/clipboard.helper";
import { InformBox } from "@/components/inform-box/InformBox.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiApiTokenCreated } from "@/types/api-user.types.ts";
import {
  Button,
  Input,
  Modal,
  ModalProps,
  Stack,
  Text,
  useModals,
  useToasts,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface ApiTokenCreatedModalProps extends ModalProps {
  token: ApiApiTokenCreated;
}

export function ApiTokenCreatedModal({ token, ...props }: ApiTokenCreatedModalProps) {
  const { close } = useModals();
  const { id } = { ...props };
  const { showInfo } = useToasts();
  const { renderDate } = useFormatter();
  const { t } = useTranslation();

  const copyToken = () => {
    void copyTextWithNotify(token.token).then((copied) => {
      if (!copied) return;
      showInfo({ title: t("common:copied") });
    });
  };

  return (
    <Modal
      {...props}
      title={t("core:api_token_created_title")}
      withCloser
      closeByOutsidePress={false}
      actions={
        <Stack gap={"smd"} direction={"vertical"}>
          <Button size={"lg"} className={"w-full"} onClick={copyToken}>
            {t("core:api_token_copy")}
          </Button>
          <Button variant={"plain"} size={"md"} className={"w-full"} onClick={() => close(id)}>
            {t("common:close")}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"md"}>
        <InformBox
          emoji={":information_source:"}
          titleClassName={"text-title"}
          title={t("core:api_token_created_warning")}
          description={t("core:api_token_created_description")}
        />
        <Input label={t("core:api_token_value")} value={token.token} readOnly />
        <Text className={"text-muted"}>
          {t("core:api_token_valid_to", { date: renderDate(token.datetime_valid_to) })}
        </Text>
      </Stack>
    </Modal>
  );
}
